import { isMockServices } from 'src/utils';
import { MutationFunction } from '@tanstack/react-query';
import { LoanChecklistRule, LoanChecklistRuleDefinition } from '../loans/types';
import mock from '../utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

export interface UpdateRuleByIdParams {
  ruleId: string;
  checklistId: string;
  name: string;
  description: string;
  definition: LoanChecklistRuleDefinition;
}

interface UpdateRuleByIdResponse {
  rule: LoanChecklistRule;
  success: boolean;
  message?: string;
}

const updateRuleById: MutationFunction<
  { success: boolean; message?: string },
  UpdateRuleByIdParams
> = async (args) => {
  if (isMockServices()) {
    return await mock(_mockUpdateRuleById, {
      delay: 2000,
      failureRate: 0,
    });
  }
  let url = `/rules`;
  let method = 'POST';
  const isEdit = args.ruleId && args.ruleId !== '' ? true : false;

  if (isEdit) {
    url = `/rules/${args.ruleId}`;
    method = 'PUT';
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<UpdateRuleByIdResponse>(url, {
    method: method,
    body: {
      ...(isEdit ? {} : { checklistId: args.checklistId }),
      name: args.name,
      description: args.description,
      definition: args.definition,
    },
  });

  if (response.status !== 200 && response.status !== 201) {
    return {
      success: false,
      message: response.data?.message ?? 'Failed to update rule',
    };
  }

  if (response.data) {
    return { success: response.data.success, message: response.data.message };
  }

  throw new Error('Failed to update rule');
};

export default updateRuleById;

const _mockUpdateRuleById = {
  success: true,
  message: 'Rule updated successfully',
} as { success: boolean; message?: string };
